import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  console.log('Protected Route:', {
    user,
    path: location.pathname,
    loading
  });

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    // Redirect to login while saving the attempted URL
    return <Navigate to="/portal" state={{ from: location }} replace />;
  }

  // For admin routes, check user role
  if (location.pathname.includes('/admin') && user.role !== 'admin') {
    return <Navigate to="/portal/cause" replace />;
  }

  console.log('ProtectedRoute rendering:', { children, pathname: location.pathname });

  return children;
};
export default ProtectedRoute;
